<template>
  <div class="privacy-policy py-4">
    <p class="pp-brand-name">MY LIFE CLICK</p>
    <p class="pp-brand-sub"><em>uma solução SIGABRAD</em></p>
    <p class="pp-brand-doc"><em>CNPJ: 44.360.218/0001-22</em></p>

    <h1 class="pp-title">
      Política de Privacidade, Proteção de Dados e Termos de Uso
    </h1>
    <p class="pp-legal-basis">
      <em
        >Conforme a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais
        – LGPD), o Marco Civil da Internet (Lei nº 12.965/2014), o Código de
        Defesa do Consumidor (Lei nº 8.078/1990) e as diretrizes vigentes da
        Autoridade Nacional de Proteção de Dados (ANPD)</em
      >
    </p>
    <p class="pp-meta">
      Versão atualizada — 25 de Agosto de 2026 · Substitui integralmente a
      versão de Agosto de 2021
    </p>

    <h2 class="pp-section">
      1. Natureza deste Documento e Responsabilidade pelo Preenchimento
    </h2>
    <p>
      Este é um documento-modelo (template), estruturado pela My Life Click /
      SIGABRAD para uso por seus clientes adquirentes — hospitais, clínicas,
      instituições de ensino, organizadores de eventos, empresas e demais
      pessoas jurídicas que licenciam a plataforma para identificação de seus
      próprios titulares (pacientes, alunos, colaboradores, participantes,
      etc.).
    </p>
    <p>
      Todos os campos indicados como "[a preencher pelo Adquirente]" ao longo
      deste documento são de responsabilidade exclusiva do Adquirente dos
      produtos My Life Click, que deverá completá-los, validá-los com sua
      própria assessoria jurídica e publicá-los antes de disponibilizar o
      serviço a seus titulares finais. A My Life Click não preenche, não valida
      e não assume responsabilidade pelo conteúdo desses campos.
    </p>

    <h2 class="pp-section">
      2. Identificação das Partes e Papéis (Controlador x Operador)
    </h2>
    <p>
      Nos termos do Art. 5º, VI e VII, da LGPD, distinguem-se dois papéis nesta
      relação:
    </p>
    <ul class="pp-list">
      <li>
        My Life Click / SIGABRAD atua, via de regra, como Operador — fornece a
        tecnologia de identificação digital (QR Code, NFC e RFID), a
        infraestrutura da plataforma e, quando contratado para tanto, o suporte
        ao tratamento de dados por conta e ordem do Adquirente.
      </li>
      <li>
        Adquirente dos produtos My Life Click: pessoa jurídica que contrata a
        plataforma e a disponibiliza a seus próprios titulares. É o Adquirente
        quem, em regra, figura como Controlador perante esses titulares finais,
        cabendo a ele as decisões sobre finalidade e forma do tratamento de
        dados coletados por meio dos braceletes, cartões e demais dispositivos
        entregues aos seus usuários.
      </li>
      <li>
        Em caso de dúvida, entrar em contato pelo e-mail
        <a href="mailto:yusefwehbe@gmail.com">yusefwehbe@gmail.com</a>
      </li>
      <li>
        <strong>Identificação do Adquirente/Controlador: </strong>
        <em class="pp-placeholder"
          >[a preencher pelo Adquirente — razão social, CNPJ, endereço e dados
          de contato]</em
        >
      </li>
    </ul>
    <p class="pp-note">
      <em
        >Nota: em implantações específicas nas quais a My Life Click opere
        diretamente de forma B2C (relação direta com o consumidor final, sem um
        Adquirente institucional intermediário), a My Life Click assume o papel
        de Controladora e deve preencher estes mesmos campos com seus próprios
        dados.</em
      >
    </p>
    <p>
      O Controlador identificado acima é responsável pelas decisões referentes
      ao tratamento de dados pessoais coletados por meio do site, dos
      braceletes, cartões e demais dispositivos de identificação com tecnologia
      QR Code, NFC e RFID, aplicativos e canais de atendimento associados à sua
      implantação da plataforma.
    </p>

    <h2 class="pp-section">3. Definições</h2>
    <ul class="pp-list">
      <li>
        <strong>Dado pessoal:</strong> informação relacionada a pessoa natural
        identificada ou identificável.
      </li>
      <li>
        <strong>Dado pessoal sensível:</strong> dado referente à saúde, origem
        étnica, convicção religiosa, opinião política, dado genético ou
        biométrico, quando vinculado a pessoa natural.
      </li>
      <li>
        <strong>Titular:</strong> pessoa natural a quem se referem os dados
        pessoais objeto de tratamento.
      </li>
      <li>
        <strong>Tratamento:</strong> toda operação realizada com dados pessoais,
        como coleta, uso, acesso, armazenamento, eliminação e compartilhamento.
      </li>
      <li>
        <strong>Controlador:</strong> pessoa jurídica a quem competem as
        decisões referentes ao tratamento de dados pessoais.
      </li>
      <li>
        <strong>Operador:</strong> pessoa jurídica que realiza o tratamento de
        dados pessoais em nome do controlador.
      </li>
      <li>
        <strong>Encarregado (DPO):</strong> pessoa indicada para atuar como
        canal de comunicação entre o controlador, os titulares e a ANPD.
      </li>
      <li><strong>ANPD:</strong> Autoridade Nacional de Proteção de Dados.</li>
    </ul>

    <h2 class="pp-section">4. Dados Pessoais Coletados</h2>
    <p>
      Em razão da natureza multivertical da plataforma — identificação de
      titulares com doenças crônicas, Transtorno do Espectro Autista e TDAH (no
      âmbito do programa PIPTEA, sob a Lei Federal nº 13.977/2020), doenças
      raras, identificação pet, segurança corporativa e grandes eventos —, o My
      Life Click poderá tratar as seguintes categorias de dados, sempre
      limitadas ao mínimo necessário para cada finalidade (princípio da
      necessidade, Art. 6º, III):
    </p>
    <h3 class="pp-subsection">4.1. Dados cadastrais</h3>
    <ul class="pp-list">
      <li>
        Nome completo, e-mail, celular, senha de acesso e idioma preferencial.
      </li>
      <li>
        Dados do responsável legal, quando o titular for criança, adolescente ou
        pessoa com deficiência sob curatela ou representação.
      </li>
    </ul>
    <h3 class="pp-subsection">
      4.2. Dados sensíveis de saúde (quando fornecidos voluntariamente pelo
      titular ou responsável)
    </h3>
    <ul class="pp-list">
      <li>
        Condições médicas, diagnósticos, alergias, medicações em uso e contatos
        de emergência, vinculados ao bracelete ou cartão de identificação.
      </li>
      <li>
        Informações relativas a diagnóstico de TEA/TDAH, exclusivamente para
        fins de identificação e proteção do titular, nos termos da Lei nº
        13.977/2020 (Lei Romeo Mion / PIPTEA).
      </li>
    </ul>
    <h3 class="pp-subsection">4.3. Dados de navegação</h3>
    <ul class="pp-list">
      <li>
        Endereço IP, tipo de dispositivo, cookies e identificadores de sessão,
        coletados conforme a Política de Cookies (Seção 13).
      </li>
    </ul>
    <h3 class="pp-subsection">4.4. Dados de terceiros vinculados</h3>
    <ul class="pp-list">
      <li>
        Quando o titular cadastra dados de dependentes, pets ou pessoas sob sua
        responsabilidade, o próprio titular é responsável por obter o
        consentimento ou possuir a base legal aplicável para o cadastro de tais
        dados.
      </li>
    </ul>

    <h2 class="pp-section">5. Finalidade e Base Legal do Tratamento</h2>
    <p>
      Cada finalidade de tratamento está associada a uma base legal específica
      prevista nos Arts. 7º e 11 da LGPD, conforme detalhado a seguir. O
      tratamento de dados sensíveis de saúde observa rigor adicional, sendo
      realizado apenas com consentimento específico, destacado e informado do
      titular ou de seu responsável legal.
    </p>
    <div class="pp-table-wrap">
      <table class="pp-table">
        <thead>
          <tr>
            <th>Finalidade do tratamento</th>
            <th>Base legal (LGPD)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Cadastro e criação de conta</td>
            <td>
              Execução de contrato / procedimentos preliminares (Art. 7º, V)
            </td>
          </tr>
          <tr>
            <td>
              Emissão e vinculação do bracelete/cartão de identificação (QR
              Code, NFC, RFID)
            </td>
            <td>
              Execução de contrato e, quando aplicável, proteção da vida ou
              incolumidade física do titular (Art. 7º, VII)
            </td>
          </tr>
          <tr>
            <td>
              Dados de saúde vinculados a doenças crônicas, TEA/TDAH (PIPTEA) e
              doenças raras
            </td>
            <td>
              Consentimento específico e destacado do titular ou de seu
              responsável legal, para tutela da saúde, em procedimento
              exclusivamente realizado por profissionais de saúde ou por
              entidades sanitárias (Art. 11, II, "f")
            </td>
          </tr>
          <tr>
            <td>Comunicações, ofertas e promoções por e-mail</td>
            <td>Consentimento (opt-in), revogável a qualquer momento</td>
          </tr>
          <tr>
            <td>Métricas de uso, analytics e cookies não essenciais</td>
            <td>
              Consentimento, conforme preferências configuradas pelo titular
            </td>
          </tr>
          <tr>
            <td>Cumprimento de obrigação legal ou regulatória</td>
            <td>Obrigação legal ou regulatória do controlador (Art. 7º, II)</td>
          </tr>
          <tr>
            <td>Prevenção a fraudes e segurança do titular</td>
            <td>
              Legítimo interesse do controlador, com avaliação de impacto (Art.
              7º, IX)
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="pp-note">
      <em
        >Nota: o consentimento para dados sensíveis é sempre solicitado em
        destaque, separado dos demais termos de uso, com finalidade específica e
        determinada, conforme Art. 11, I, da LGPD.</em
      >
    </p>

    <h2 class="pp-section">6. Consentimento</h2>
    <p>
      O consentimento é livre, informado e inequívoco, coletado por meio de
      mecanismo de aceite ativo (não pré-marcado), no momento do cadastro. O
      titular pode revogar o consentimento a qualquer momento, mediante
      solicitação ao Encarregado, sem prejuízo da licitude do tratamento
      realizado antes da revogação.
    </p>
    <p>
      Para dados de crianças e adolescentes, o consentimento é obtido
      especificamente do responsável legal, observado o melhor interesse da
      criança, conforme Art. 14 da LGPD e o Estatuto da Criança e do
      Adolescente.
    </p>

    <h2 class="pp-section">7. Compartilhamento de Dados</h2>
    <p>
      O My Life Click não compartilha dados pessoais com terceiros para fins
      comerciais alheios à prestação do serviço. O compartilhamento ocorre,
      exclusivamente, nas seguintes hipóteses:
    </p>
    <ul class="pp-list">
      <li>
        Com operadores contratados para hospedagem, processamento de pagamentos
        e suporte técnico, mediante contrato que assegure padrão de proteção
        equivalente.
      </li>
      <li>
        Com profissionais de saúde, equipes de emergência ou entidades públicas,
        no momento da leitura do QR Code/NFC, para fins de proteção da vida e da
        incolumidade física do titular.
      </li>
      <li>
        Com parceiros institucionais (hospitais, clínicas, entidades de apoio a
        doenças raras, instituições de ensino), exclusivamente mediante base
        legal e/ou consentimento específico do titular.
      </li>
      <li>
        Por determinação legal, ordem judicial ou requisição de autoridade
        competente.
      </li>
    </ul>
    <p>
      O Controlador exige de todos os operadores e parceiros o cumprimento de
      obrigações equivalentes às previstas na LGPD, formalizadas em contrato ou
      termo de tratamento de dados (DPA).
    </p>

    <h2 class="pp-section">8. Transferência Internacional de Dados</h2>
    <p>
      Caso dados pessoais sejam transferidos a servidores ou prestadores de
      serviço localizados fora do território nacional, tal transferência
      observará uma das hipóteses do Art. 33 da LGPD, incluindo a existência de
      decisão de adequação da ANPD, cláusulas contratuais padrão, normas
      corporativas globais ou selos e certificados reconhecidos, garantindo-se
      nível de proteção adequado aos dados transferidos.
    </p>

    <h2 class="pp-section">9. Retenção e Eliminação de Dados</h2>
    <p>
      Os dados pessoais são mantidos apenas pelo período necessário ao
      cumprimento das finalidades para as quais foram coletados, observados os
      prazos de guarda obrigatória previstos em lei (fiscal, cível e
      regulatória). Encerrada a finalidade, os dados são eliminados ou
      anonimizados, ressalvadas as hipóteses do Art. 16 da LGPD (cumprimento de
      obrigação legal, estudo por órgão de pesquisa, transferência a terceiro
      respeitados os requisitos de tratamento, ou uso exclusivo do controlador,
      vedado o acesso por terceiro, e desde que anonimizados os dados).
    </p>

    <h2 class="pp-section">10. Segurança da Informação</h2>
    <p>
      O Controlador adota medidas técnicas e administrativas aptas a proteger os
      dados pessoais de acessos não autorizados e de situações acidentais ou
      ilícitas de destruição, perda, alteração, comunicação ou difusão,
      incluindo: criptografia de dados sensíveis em trânsito e em repouso,
      controle de acesso por perfil (least privilege), autenticação de múltiplos
      fatores para acesso administrativo, registro (log) de acessos e trilha de
      auditoria, e testes periódicos de segurança.
    </p>
    <p>
      Em caso de incidente de segurança que possa acarretar risco ou dano
      relevante aos titulares, o Controlador comunicará à ANPD e aos titulares
      afetados em prazo razoável, conforme Art. 48 da LGPD, informando a
      natureza dos dados afetados, as medidas técnicas adotadas e os riscos
      relacionados ao incidente.
    </p>

    <h2 class="pp-section">11. Direitos do Titular dos Dados</h2>
    <p>
      Nos termos do Art. 18 da LGPD, o titular tem direito a obter do
      Controlador, a qualquer momento e mediante requisição:
    </p>
    <div class="pp-table-wrap">
      <table class="pp-table pp-table--rights">
        <tbody>
          <tr>
            <th>Confirmação e acesso</th>
            <td>
              Saber se seus dados são tratados e acessar o conteúdo tratado.
            </td>
          </tr>
          <tr>
            <th>Correção</th>
            <td>Corrigir dados incompletos, inexatos ou desatualizados.</td>
          </tr>
          <tr>
            <th>Anonimização, bloqueio ou eliminação</th>
            <td>
              De dados desnecessários, excessivos ou tratados em desconformidade
              com a LGPD.
            </td>
          </tr>
          <tr>
            <th>Portabilidade</th>
            <td>
              Solicitar a transferência dos dados a outro fornecedor de serviço,
              mediante requisição expressa.
            </td>
          </tr>
          <tr>
            <th>Eliminação</th>
            <td>
              Eliminação dos dados pessoais tratados com consentimento,
              ressalvadas hipóteses de guarda obrigatória.
            </td>
          </tr>
          <tr>
            <th>Informação sobre compartilhamento</th>
            <td>
              Saber com quais entidades públicas e privadas o controlador
              compartilhou dados.
            </td>
          </tr>
          <tr>
            <th>Informação sobre a possibilidade de não consentir</th>
            <td>E as consequências da negativa.</td>
          </tr>
          <tr>
            <th>Revogação do consentimento</th>
            <td>
              A qualquer momento, mediante manifestação expressa, sem afetar a
              licitude do tratamento anterior.
            </td>
          </tr>
          <tr>
            <th>Revisão de decisões automatizadas</th>
            <td>
              Solicitar revisão humana de decisões tomadas unicamente com base
              em tratamento automatizado.
            </td>
          </tr>
          <tr>
            <th>Oposição</th>
            <td>
              Opor-se a tratamento realizado com base em hipótese legal diversa
              do consentimento, em caso de descumprimento à LGPD.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      As solicitações podem ser realizadas por meio do canal indicado na Seção
      12 e serão respondidas em prazo razoável, observados os prazos
      regulamentares da ANPD.
    </p>

    <h2 class="pp-section">12. Encarregado de Proteção de Dados (DPO)</h2>
    <p>
      O Controlador (Adquirente, conforme Seção 2) designa um Encarregado de
      Proteção de Dados (Data Protection Officer), responsável por atender
      solicitações dos titulares, comunicar-se com a ANPD e orientar os
      colaboradores quanto às práticas de proteção de dados.
    </p>
    <p>
      <strong>Canal de atendimento ao titular / Encarregado: </strong>
      <em class="pp-placeholder"
        >[a preencher pelo Adquirente — nome do Encarregado, e-mail dedicado de
        privacidade e canal de contato oficial]</em
      >
    </p>
    <p class="pp-note">
      <em
        >Campo de responsabilidade exclusiva do Adquirente, a ser preenchido
        antes da publicação deste documento a seus titulares — recomenda-se
        e-mail dedicado de privacidade, distinto do e-mail comercial, para
        rastreabilidade das solicitações recebidas.</em
      >
    </p>

    <h2 class="pp-section">13. Cookies</h2>
    <p>
      O site e a plataforma My Life Click utilizam cookies para viabilizar
      funcionalidades essenciais (conta, login, processamento de pedidos),
      melhorar a experiência do usuário e realizar análise de uso, inclusive por
      meio de ferramentas de terceiros como Google Analytics.
    </p>
    <h3 class="pp-subsection">13.1. Categorias de cookies</h3>
    <ul class="pp-list">
      <li>
        Estritamente necessários: essenciais ao funcionamento do site e à
        segurança da conta; não exigem consentimento prévio.
      </li>
      <li>
        De desempenho e analytics: coletam dados agregados sobre uso do site;
        requerem consentimento do titular.
      </li>
      <li>
        De funcionalidade: memorizam preferências do usuário (idioma,
        configurações).
      </li>
      <li>
        De terceiros: cookies definidos por parceiros de análise, sujeitos às
        respectivas políticas de privacidade.
      </li>
    </ul>
    <p>
      O titular pode gerenciar suas preferências de cookies a qualquer momento
      por meio do banner de consentimento ou das configurações do navegador. A
      desativação de cookies não essenciais não afeta o funcionamento básico do
      site; a desativação de cookies essenciais pode comprometer funcionalidades
      como login e processamento de pedidos.
    </p>

    <h2 class="pp-section">
      14. Dados de Crianças, Adolescentes e Pessoas com Deficiência
    </h2>
    <p>
      Considerando que parte das verticais do My Life Click destina-se à
      identificação de crianças e pessoas com Transtorno do Espectro Autista
      (programa PIPTEA), o tratamento de dados desses titulares observa proteção
      reforçada: coleta limitada ao estritamente necessário para a finalidade de
      identificação e proteção, consentimento específico do responsável legal,
      vedação de uso dos dados para fins publicitários direcionados a essas
      categorias de titulares, e possibilidade de exclusão dos dados a qualquer
      momento mediante solicitação do responsável legal.
    </p>

    <h2 class="pp-section">15. Compromisso do Usuário</h2>
    <p>Ao utilizar a plataforma My Life Click, o usuário compromete-se a:</p>
    <ul class="pp-list">
      <li>
        Não utilizar os serviços para finalidades ilícitas ou contrárias à ordem
        pública.
      </li>
      <li>
        Não difundir conteúdo discriminatório, racista, xenofóbico, de apologia
        à violência ou a atividades ilegais.
      </li>
      <li>
        Não tentar comprometer a segurança dos sistemas do Controlador, de
        fornecedores ou de terceiros, incluindo tentativas de introdução de
        vírus, malware ou engenharia reversa não autorizada.
      </li>
      <li>
        Fornecer informações verdadeiras, precisas e atualizadas no momento do
        cadastro.
      </li>
    </ul>

    <h2 class="pp-section">16. Propriedade Intelectual e Licença de Uso</h2>
    <p>
      Os materiais disponibilizados no site e na plataforma My Life Click
      (textos, marca, layout, software e tecnologia de identificação QR
      Code/NFC/RFID) são protegidos por direitos autorais e de propriedade
      industrial. É concedida ao usuário licença limitada, pessoal, não
      exclusiva e intransferível para uso dos serviços conforme sua finalidade,
      vedadas a cópia, modificação, engenharia reversa, distribuição ou
      exploração comercial não autorizada dos materiais.
    </p>

    <h2 class="pp-section">17. Isenção e Limitação de Responsabilidade</h2>
    <p>
      Os materiais e serviços são fornecidos "como estão". O My Life Click não
      garante ausência de erros técnicos, atualização contínua dos conteúdos ou
      disponibilidade ininterrupta da plataforma, e não se responsabiliza por
      danos indiretos decorrentes do uso ou da impossibilidade de uso dos
      serviços, ressalvadas as hipóteses de dolo, culpa grave ou violação de
      norma de proteção de dados imputável ao Controlador, nos termos do Código
      de Defesa do Consumidor e da LGPD.
    </p>
    <p class="pp-note">
      <em
        >Nota: cláusulas de limitação de responsabilidade frente a consumidores
        estão sujeitas às normas de ordem pública do CDC, que veda a exoneração
        de responsabilidade em hipóteses de vício ou defeito do serviço;
        recomenda-se validação jurídica desta seção conforme o público-alvo
        (B2C, B2B ou setor público).</em
      >
    </p>

    <h2 class="pp-section">18. Links para Sites Externos</h2>
    <p>
      A plataforma pode conter links para sites de terceiros. O My Life Click
      não analisa nem se responsabiliza pelo conteúdo, práticas de privacidade
      ou segurança de sites externos, sendo o acesso a tais sites de
      responsabilidade exclusiva do usuário.
    </p>

    <h2 class="pp-section">19. Alterações desta Política</h2>
    <p>
      Esta Política poderá ser atualizada a qualquer momento, para refletir
      alterações legislativas, regulatórias ou operacionais. Alterações
      relevantes serão comunicadas aos titulares por e-mail ou por aviso
      destacado na plataforma, com indicação da nova data de vigência. O uso
      continuado dos serviços após a comunicação da alteração implica ciência
      dos novos termos.
    </p>

    <h2 class="pp-section">20. Legislação Aplicável e Foro</h2>
    <p>
      Esta Política é regida pelas leis da República Federativa do Brasil, em
      especial pela Lei nº 13.709/2018 (LGPD), pela Lei nº 12.965/2014 (Marco
      Civil da Internet) e pelo Código de Defesa do Consumidor. Fica eleito o
      foro do domicílio do titular/consumidor para dirimir controvérsias
      oriundas desta Política, ressalvada competência diversa prevista em lei,
      sendo vedada a eleição de foro que dificulte o acesso do titular à
      Justiça.
    </p>

    <h2 class="pp-section">21. Vigência</h2>
    <p>
      Esta Política entra em vigor a partir de 25 de agosto de 2026 e substitui
      integralmente qualquer versão anterior publicada pelo Adquirente.
    </p>

    <hr class="pp-divider" />
    <p class="pp-footnote">
      <em
        >Este documento foi elaborado pela My Life Click para fins de
        organização e atualização de conteúdo, com base na legislação brasileira
        de proteção de dados (LGPD) e nas melhores práticas de mercado, na
        condição de modelo (template) a ser adaptado por cada Adquirente. O
        preenchimento, a validação e a publicação dos campos indicados como "[a
        preencher pelo Adquirente]" são de responsabilidade exclusiva do
        Adquirente dos produtos My Life Click, cabendo-lhe também a análise por
        advogado ou escritório especializado em proteção de dados e direito
        digital habilitado em sua jurisdição, a adequação ao seu porte e setor
        de atuação (de órgãos públicos a multinacionais) e a elaboração de
        Relatório de Impacto à Proteção de Dados (RIPD), recomendado dado o
        tratamento de dados sensíveis de saúde. A My Life Click não se
        responsabiliza pelo conteúdo inserido pelo Adquirente nesses campos.</em
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy-policy-pt-br",
};
</script>
